import { ResponsibleMedicalRecordRepository } from '../repositories/ResponsibleMedicalRecordRepository'

export function ListResponsibleMedicalRecordUseCase(
  repository: ResponsibleMedicalRecordRepository
) {
  return async (params: {
    status?: string
    personaName?: string
    month?: number
    year?: number
  }) => {
    return await repository.listResponsibleMedicalRecord(params)
  }
}
